import { render } from "./tutorial-rustdesk.vue?vue&type=template&id=44bab763&ts=true"
import script from "./tutorial-rustdesk.vue?vue&type=script&lang=ts"
export * from "./tutorial-rustdesk.vue?vue&type=script&lang=ts"

import "./tutorial-rustdesk.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__